import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ChecklistItem = ({ title, subtitle, completed, onStart, isLast }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 2.5,
        py: 2,
        borderBottom: isLast ? 'none' : '1px solid',
        borderColor: 'divider',
        transition: 'background 0.2s',
        '&:hover': {
          bgcolor: completed ? 'transparent' : 'action.hover',
        },
      }}
    >
      {/* Check circle */}
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          ...(completed
            ? {
                bgcolor: '#c9a96e',
                color: '#fff',
              }
            : {
                border: '2px solid',
                borderColor: 'divider',
              }),
          transition: 'all 0.3s ease',
        }}
      >
        {completed && <Check size={16} strokeWidth={3} />}
      </Box>

      {/* Text */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontSize: 14,
            color: completed ? 'text.secondary' : 'text.primary',
            textDecoration: completed ? 'line-through' : 'none',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', fontSize: 13, mt: 0.25 }}
        >
          {subtitle}
        </Typography>
      </Box>

      {/* Action button */}
      {completed ? (
        <Typography
          variant="caption"
          sx={{ color: '#c9a96e', fontWeight: 600, whiteSpace: 'nowrap' }}
        >
          {t('onboarding_checklist.completed', 'Completed')}
        </Typography>
      ) : (
        <Button
          size="small"
          onClick={onStart}
          sx={{
            bgcolor: 'rgba(201, 169, 110, 0.1)',
            color: '#c9a96e',
            fontWeight: 600,
            fontSize: 13,
            textTransform: 'none',
            px: 2,
            borderRadius: '8px',
            whiteSpace: 'nowrap',
            '&:hover': {
              bgcolor: 'rgba(201, 169, 110, 0.2)',
            },
          }}
        >
          {t('onboarding_checklist.start', 'Start')} →
        </Button>
      )}
    </Box>
  );
};

export default ChecklistItem;
